import React from 'react';

interface LegalLinksProps {
  links: Array<{
    Href: string;
    Text: string;
  }>;
}

export const LegalLinks = ({ links }: LegalLinksProps) => {
  return (
    <div className='l-legal-links'>
      {links.map((link, index) => {
        return (
          <a key={index} className='c-legal-link custom' href={link.Href}>
            {link.Text}
          </a>
        );
      })}
    </div>
  );
};
